module.exports = __webpack_public_path__ + "static/media/FiidoLogo.37ef022d.webp";